import React from 'react';
import PropTypes from 'prop-types';
import colors from 'hsl-shared-components/lib/Theme/colors';
import styled from 'styled-components';
import arrowIcon from '../../assets/icons/icon-arrow-right.svg';
import { MOBILE_BREAKPOINT_IN_PX } from '../../constants';

const BackButtonWrapper = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  height: 24px;

  &:hover {
    a {
      text-decoration: underline;
    }
  }
`;

const ArrowIcon = styled.div`
  width: 27px;
  height: 24px;
  background-image: url(${arrowIcon});
  background-size: 12px 14px;
  background-repeat: no-repeat;
  background-position: center left;
  margin-left: 13px;

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    width: 20px;
  }
`;

const Text = styled.div`
  display: flex;
  top: 1px;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: -0.02em;
  line-height: 19px;
  color: ${colors.primary.hslGreyDark};

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    font-size: 16px;
    letter-spacing: -0.02em;
    line-height: 19px;
  }
`;

const TextLink = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  top: 1px;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: -0.02em;
  line-height: 19px;
  color: ${colors.primary.hslBlue};
  cursor: pointer;

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    font-size: 16px;
    letter-spacing: -0.02em;
    line-height: 19px;
  }
`;

const BackButton = ({ text, onClick }) => (
  <BackButtonWrapper>
    {!onClick && <Text>{text}</Text>}
    {onClick && (
      <>
        <TextLink onClick={onClick}>{text}</TextLink>
        <ArrowIcon />
      </>
    )}
  </BackButtonWrapper>
);

BackButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

BackButton.defaultProps = {
  onClick: null,
};

export default BackButton;
